import React, {useContext} from "react";

import LookWizardContext from "./lookWizardContext";
import FeatureThumbnail from "../../../../visComponents/featureThumbnail";


const LookWizardContentCustomGroup = () => {

  const {selectedWizardCustomGroup, featureGroupFeature} = useContext(LookWizardContext);
  const {customImageUrl, uploadedImageUrl} = selectedWizardCustomGroup;

  return (
    <div className="lw-content__other pt-075">
      <div className="grohe-feature grohe-wizard__feature h-auto">
        {customImageUrl || uploadedImageUrl ? (
          <div className="lk-image">
            <div className="lk-image__main">
              <div className="lk-image__main-image-container">
                <img className={"lk-image__main-image"}
                     src={customImageUrl || uploadedImageUrl}
                     alt=""/>
              </div>
            </div>
          </div>
        ) : null}
        {!customImageUrl && !uploadedImageUrl && featureGroupFeature ? (
          <FeatureThumbnail feature={featureGroupFeature}
                            dbFeatureId={featureGroupFeature.dbFeature.id}/>
        ) : null}
        <div className="lk-title mt-1">
          <h2 className="lk-title__text h-auto">
            {selectedWizardCustomGroup.productCartTitle || selectedWizardCustomGroup.title || selectedWizardCustomGroup.groupName}
          </h2>
        </div>
        {selectedWizardCustomGroup.productCartDescription ? (
          <p className="lm-feature__content-description pt-0">{selectedWizardCustomGroup.productCartDescription}</p>
        ) : null}
      </div>
    </div>
  )
};

export default LookWizardContentCustomGroup
